/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.0.1
 */

import { ReactNode } from 'react';

import { ExternalLinkStyled } from './styled/ExternalLinkStyled';

export enum ELinkTarget {
    BLANK = '_blank',
    PARENT = '_parent',
    SELF = '_self',
    TOP = '_top',
}

interface IExternalLinkProp {
    children: ReactNode;
    href: string;
    onClick?: () => void;
    target?: ELinkTarget;
}

const ExternalLink = (props: IExternalLinkProp) => (
    <ExternalLinkStyled href={props.href} target={props.target} onClick={props.onClick}>
        {props.children}
    </ExternalLinkStyled>
);

export default ExternalLink;
